/**
 * Manager who provide user location
 */

import Logger from '../../utils/Logger'
import Service from '../../services/Service'
import ConfigGps from '../../configuration/config/ConfigGps'
import GpsManager from '../manager/GpsManager'

export default class GpsService extends Service {

    constructor(gpsConfiguration) {
        Logger.log('GPS init');
        super();
        this.configuration = gpsConfiguration;
        this.reverseGeocodingFunction = null;
    }

    /**
     * Start GPS Manager
     */
    start() {
        this.gpsManager = new GpsManager(
            this.configuration,
            this.reverseGeocodingFunction
        );
        this.gpsManager.start();
    }

    /**
     * Stop GPSManager
     */
    stop() {
        this.gpsManager.stop();
    }

    /**
     * Restart GPS Manager
     */
    restart() {
        this.stop();
        this.start();
    }

    /**
     * Merge global GPS configuration and scenario GPS configuration
     *
     * @param scenarioGpsconfiguration A ConfigGps object
     * @returns {ConfigGps}
     */
    mergeConfig(scenarioGpsconfiguration) {
        if (scenarioGpsconfiguration) {
            return new ConfigGps(scenarioGpsconfiguration.enabled, this.configuration.geocodingEnabled, scenarioGpsconfiguration.searchTime, scenarioGpsconfiguration.accuracy);
        } else {
            return this.configuration;
        }
    }

    /**
     * Set a reverse geocoding function to enrich GPS data from client side
     * The callback should get 3 parameters
     *
     * @param reverseGeocodingFunction A function with 3 parameters (latitude, longitude, another callback to alert SDK when enrichment is successfully done)
     */
    setReverseGeocodingFunction(reverseGeocodingFunction) {
        this.reverseGeocodingFunction = reverseGeocodingFunction;
    }


    /**
     * Provides a GpsManager where start / stop methods can be called
     *
     * @param scenarioGpsconfiguration Optional
     * @returns {GpsManager}
     */
    provide(scenarioGpsconfiguration) {
        return new GpsManager(
            this.mergeConfig(scenarioGpsconfiguration),
            this.reverseGeocodingFunction
        );
    }
}


// WEBPACK FOOTER //
// ./js/core/gps/service/GpsService.js